// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__24Ri0","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1OF8T"};